import { FC_URL, GECCO_URL, ACTIVITY_URL } from "common/constants/apiUrls";
import { activityUrl, futureCareUrl, geccoUrl } from "common/constants/apiUrls";
import { productsList } from "common/constants/constants";
import { getData } from "networkManager/NetworkManager";

export const getGeccoFilesStat = async (filter, branchId) => {
  let url = geccoUrl.uploadedFilesGraph + "/" + filter;
  if (branchId) {
    url += "?branchId=" + branchId;
  }
  return await getData(url, GECCO_URL);
};

export const getUsersCount = async (branchId) => {
  let url = activityUrl.usersCount;
  if (branchId) {
    url += "?branchId=" + branchId;
  }
  return await getData(url);
};
export const getGeccoUsers = async (filter, branchId) => {
  let url = `${ACTIVITY_URL}/${productsList[0].id}/users?input=${filter}`;
  if (branchId) {
    url += "&branchId=" + branchId;
  }
  return await getData(url);
};
export const getFcUsers = async (filter, branchId) => {
  let url = `${ACTIVITY_URL}/${productsList[1].id}/users?input=${filter}`;
  if (branchId) {
    url += "&branchId=" + branchId;
  }
  return await getData(url);
};
export const getFcBoaData = async (filter, branchId) => {
  let url = futureCareUrl.boaChartData + filter;
  if (branchId) {
    url += "?branchId=" + branchId;
  }
  return await getData(url, FC_URL);
};
export const getFcFamilyTreeData = async (filter, branchId) => {
  let url = futureCareUrl.familyTreeChartData + filter;
  if (branchId) {
    url += "?branchId=" + branchId;
  }
  return await getData(url, FC_URL);
};
export const getFcStatusQuoData = async (filter, branchId) => {
  let url = futureCareUrl.statusQuoChartData + filter;
  if (branchId) {
    url += "?branchId=" + branchId;
  }
  return await getData(url, FC_URL);
};
